<atlas-item *ngIf="interactable$ | async; else noOtherLocations" interactable (click)="showSwitchLocationDialog()">
  <ng-content *ngTemplateOutlet="locationSelector"></ng-content>
</atlas-item>

<ng-template #noOtherLocations>
  <atlas-item>
    <ng-content *ngTemplateOutlet="locationSelector"></ng-content>
  </atlas-item>
</ng-template>

<ng-template #locationSelector>
  <ng-container *ngIf="currentLocationName$ | async as locationName">
    <div class="location-info">
      <div class="name-and-address">
        <span class="name">
          {{ locationName }}
        </span>
        <span class="address" *ngIf="currentLocationAddress$ | async as locationAddress">
          {{ locationAddress }}
        </span>
      </div>
      <i class="material-icons" *ngIf="interactable$ | async">arrow_drop_down</i>
    </div>
  </ng-container>
</ng-template>
